<template>
  <div class="detail-page">
    <van-nav-bar
      :title="detailData.IDNO || '单据详情'"
      left-arrow
      fixed
      @click-left="onClickLeft"
    />

    <div class="content-wrapper">
      <div class="content">
      <van-loading v-if="loading" type="spinner" size="40" vertical style="padding: 60px 0;">
        加载中...
      </van-loading>

      <template v-else>
        <!-- B部分：表头信息卡片 -->
      <div class="detail-card">
        <div class="card-title">报销单基础信息</div>

        <div class="info-list">
          <div class="info-item">
            <span class="info-label">报销用户：</span>
            <span class="info-value">{{ detailData.EMPNO || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">发生类型：</span>
            <span class="info-value">
              <van-tag type="primary" plain >{{ detailData.HAPPENM || '-' }}</van-tag>
            </span>
          </div>
          <div class="info-item">
            <span class="info-label">报销总金额：</span>
            <span class="info-value amount-text">{{ detailData.TTLAMT || '0.00' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">收款单位/人：</span>
            <span class="info-value">{{ detailData.RCVER || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">分摊类型：</span>
            <span class="info-value">
              <van-tag type="primary" plain >{{ detailData.DISTYNM || '-' }}</van-tag>
            </span>
          </div>
          <div class="info-item">
            <span class="info-label">单据日期：</span>
            <span class="info-value">{{ detailData.DTTM || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">付款期限：</span>
            <span class="info-value">{{ detailData.PAYDTTM || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">收款账号：</span>
            <span class="info-value">{{ detailData.BANKNO || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">开户银行：</span>
            <span class="info-value">{{ detailData.BANKNM || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">借款/预支余额：</span>
            <span class="info-value">{{ detailData.PREAMT || '0.00' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">含税：</span>
            <span class="info-value">
               <van-tag :type="detailData.ISTAX === 'Y' ? 'success' : 'default'" >
                  {{ detailData.ISTAX === 'Y' ? '是' : '否' }}
                </van-tag>
            </span>
          </div>
        </div>

        <div class="reason-section" v-if="detailData.RMK">
          <div class="section-title">备注说明</div>
          <div class="reason-content">{{ detailData.RMK }}</div>
        </div>
      </div>
      <div class="table-card">
        <div class="card-title">报销明细</div>

        <div class="table-wrapper">
          <div class="table-scroll">
            <table class="detail-table">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>关联单据类型</th>
                  <th>关联单据编码</th>
                  <th>财务科目</th>
                  <th>币种</th>
                  <th>报销事由</th>
                  <th>申请报销费用</th>
                  <th>付款状态</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in detailList" :key="item.LSTSEQ">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.REFTY || '-' }}</td>
                  <td>{{ item.REFNO || '-' }}</td>
                  <td>{{ item.ACCTNM }}</td>
                  <td>{{ item.CURNM }}</td>
                  <td class="reason-cell">{{ item.REASON }}</td>
                  <td class="amount-cell">{{ item.AMT }}</td>
                  <td>
                    <span :class="getPayStatusClass(item.PAYSTFG)">
                      {{ getPayStatusText(item.PAYSTFG) }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>


        </div>
        <div class="total-row" v-if="detailList.length > 0">
          <span class="total-label">合计：</span>
          <span class="total-amount">{{ totalAmount }}</span>
        </div>
      </div>
      <div class="table-card">
        <div class="card-title">跟进备注</div>

        <div class="table-wrapper">
          <van-field
            v-model="v_rmk"
            rows="3"
            autosize
            type="textarea"
            placeholder="请输入备注"
            style="margin: 16px;"
          />
        </div>
      </div>
      </template>
    </div>
    </div>
    <div class="action-bar">
      <van-button
        type="danger"
        size="large"
        @click="handleReject"
        style="width: 48%;"
      >驳回
      </van-button>
      <van-button
        type="primary"
        size="large"
        @click="handleApprove"
        style="width: 48%;"
      >
        通过
      </van-button>
    </div>
  </div>
</template>

<script>
import { handleApprovalAction, backToList } from './approval'

export default {
  name: 'ExpenseDetail',
  data() {
    return {
      idseq: '',
      idno: '',
      v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
      v_username: this.$cookies.get('v_telno'),
      v_corpid: this.$cookies.get('v_corpid'),
      v_cfmRow: {},
      detailData: {},
      detailList: [],
      showDialog: false,
      dialogTitle: '',
      approvalComment: '',
      currentAction: '', // 'approve' or 'reject'
      loading: false,
      v_rmk: '',
      fromRoute: 'list' // 记录来源：'list' 或 'index'
    }
  },
  computed: {
    // 计算总金额
    totalAmount() {
      return this.detailList.reduce((sum, item) => {
        return sum + parseFloat(item.AMT || 0)
      }, 0).toFixed(2)
    }
  },
  mounted() {
    if (this.$route.params.itemData) {
      const item = this.$route.params.itemData
      this.idseq = item.IDSEQ
      this.idno = item.IDNO
      this.v_cfmRow = item
    }

    if (this.idno) {
      this.getFinFee()
    }
  },
  methods: {
    // 获取报销单主表数据
    getFinFee() {
      this.loading = true
      this.$axios({
        method: 'post',
        url: 'xuper_auth/getBaseData',
        data: {
          p_key: "IDNO",
          p_value: this.idno,
          p_key2: "corpid",
          p_value2: this.v_corpid,
          p_table: "V_FIN_FEE"
        }
      }).then(res => {
        if (res.code === '200' && res.result && res.result.length > 0) {
          this.detailData = res.result[0]

          // 获取报销明细
          this.getFinFeeDetail(res.result[0].IDSEQ)
        } else {
          this.$toast.fail('未找到报销单数据')
        }
      }).catch(err => {
        this.$toast.fail('加载数据失败')
      }).finally(() => {
        this.loading = false
      })
    },

    // 获取报销单明细数据
    getFinFeeDetail(IDSEQ) {
      this.$axios({
        method: 'post',
        url: 'xuper_auth/getBaseData',
        data: {
          p_key: "IDSEQ",
          p_value: IDSEQ,
          p_table: "V_FIN_FEEDTL"
        }
      }).then(res => {
        if (res.code === '200' && res.result) {
          this.detailList = res.result.map(item => ({
            LSTSEQ: item.LSTSEQ,
            REFTY: item.REFIDTY,  // 关联单据类型
            REFNO: item.REFIDNO,  // 关联单据编码
            ACCTNM: item.ACNM,  // 财务科目
            CURNM: item.CRCY,  // 币种
            REASON: item.REASON || item.RMK,  // 报销事由
            AMT: item.CHKAMT,  // 申请报销费用
            PAYSTFG: item.PAYFLAG === '未付款' ? 'N' : (item.PAYFLAG === '已付款' ? 'Y' : 'P')  // 付款状态
          }))
        }
      }).catch(err => {
        this.$toast.fail(err)
      })
    },
    // 驳回审批
    handleReject(){
      handleApprovalAction(this, 'reject')
    },
    // 通过审批
    handleApprove() {
      handleApprovalAction(this, 'approve')
    },
    // 返回
    onClickLeft() {
      const from = this.$route.query.from
      if (from === 'index') {
        this.$router.push('/approval')
      } else {
        backToList(this, 'ORD')
      }
    },

    // 获取付款状态样式
    getPayStatusClass(status) {
      const classMap = {
        'N': 'pay-status-pending',
        'Y': 'pay-status-paid',
        'P': 'pay-status-partial'
      }
      return classMap[status] || 'pay-status-pending'
    },

    // 获取付款状态文本
    getPayStatusText(status) {
      const textMap = {
        'N': '未付款',
        'Y': '已付款',
        'P': '部分付款'
      }
      return textMap[status] || '未付款'
    }
  }
}
</script>

<style scoped lang="scss">
.detail-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f7f8fa;
}
.content-wrapper {
  flex: 1;
  overflow-y: auto;
  margin-top: 46px;
  margin-bottom: 72px;
  padding: 12px;
}
.van-nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}
.action-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  z-index: 100;
}
.detail-card,
.table-card {
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 12px;
  .card-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #323233;
  }
  .info-list {
    .info-item {
      display: flex;
      align-items: flex-start;
      padding: 8px 0;
      border-bottom: 1px solid #EBEDF0;

      &:last-child {
        border-bottom: none;
      }

      .info-label {
        min-width: 90px;
        font-size: 14px;
        font-weight: 500;
        color: #646566;
        flex-shrink: 0;
        line-height: 22px;
      }

      .info-value {
        flex: 1;
        font-size: 14px;
        color: #323233;
        font-weight: 600;
        word-break: break-all;
        line-height: 22px;

        &.amount-text {
          color: #FF4000;
          font-weight: 600;
        }
      }
    }
  }

  .reason-section {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #f0f0f0;
    .section-title {
      color: #646566;
      font-weight: 500;
      margin-bottom: 8px;
    }
    .reason-content {
      color: #323233;
      line-height: 1.6;
      word-break: break-word;
    }
  }
}

/* 表格滚动 */
.table-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.detail-table {
  width: 100%;
  min-width: 750px;
  border-collapse: collapse;
  font-size: 13px;
  th, td {
    padding: 8px 6px;
    border-bottom: 1px solid #f0f0f0;
    text-align: left;
    color: #646566;
    word-break: break-word;
  }
  th {
    background: #f7f8fa;
    font-weight: 600;
    white-space: nowrap;
  }
  .amount-cell {
    color: #f44336;
    font-weight: 600;
    white-space: nowrap;
  }
  .reason-cell {
    max-width: 180px;
  }
}
.total-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
  .total-label {
    font-weight: 600;
    margin-right: 8px;
  }
  .total-amount {
    font-weight: 700;
    color: #f44336;
  }
}

.pay-status-pending { color: #ff9800; font-size: 12px; }
.pay-status-paid    { color: #4caf50; font-size: 12px; }
.pay-status-partial { color: #2196f3; font-size: 12px; }
</style>
